<template>
  <v-container
    class="pt-4"
    fluid
  >
    <v-row>
      <v-col cols="12">
        <v-select
          v-model="currentSociety"
          :items="socData"
          item-text="name"
          item-value="id_soc"
          :label="$t('akito.account-name')"
          dense
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-text-field
          v-model="userData.login"
          :rules="[rules.required]"
          :label="$t('profile.sections.user.login')"
          :append-icon="iconAvailable"
          dense
          :background-color="colorAvailable"
          :disabled="!socIsValid"
          @change="checkName()"
        />
      </v-col>
      <v-col cols="6">
        <v-row>
          <v-col cols="9">
            <v-text-field
              v-model="userData.password"
              :rules="[rules.required, rules.min]"
              :label="$t('profile.sections.user.password')"
              :disabled="!socIsValid"
              counter
              dense
              @click:append="show = !show"
            />
          </v-col>
          <v-col cols="3">
            <v-btn
              icon
              @click="randomPass()"
            >
              <v-icon>mdi-autorenew</v-icon>
            </v-btn>
            <v-btn
              icon
              @click="copy()"
            >
              <v-icon>mdi-content-copy</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-text-field
          v-model="userData.name"
          :rules="[rules.required]"
          :label="$t('profile.sections.common.name')"
          :disabled="!socIsValid"
          dense
        />
      </v-col>
      <v-col cols="6">
        <v-text-field
          v-model="userData.firstname"
          :rules="[rules.required]"
          :label="$t('profile.sections.user.firstname')"
          :disabled="!socIsValid"
          dense
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="userData.phone"
          :label="$t('profile.sections.user.phone')"
          :disabled="!socIsValid"
          dense
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-btn
          color="success"
          class="mr-4"
          :disabled="userData.login.length < 6 || userData.password.length < 8 || !nameAvailable || disableButton"
          @click="createUserData()"
        >
          <v-icon class="mr-2">mdi-content-save-outline</v-icon>
          {{ $t("akito.create") }}
        </v-btn>
        <v-btn
          :disabled="userData.login.length < 1 || !socIsValid"
          color="warning"
          @click="autoComplete()"
        >
          <v-icon class="mr-2">mdi-auto-fix</v-icon>
          {{ $t("akito.auto-complete") }}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// Connectors
import { ProfileSocietyConnector } from "../../Database/ProfileSocietyConnector.js";

export default {
  data() {
    return {
      societyConnector: new ProfileSocietyConnector(this.$store.state.user),
      show: false,
      userData: {
        soc_id: "",
        login: "",
        password: "",
        name: "",
        firstname: "",
        phone: "",
        access: "",
      },
      size: 8,
      characters: "a-z,A-Z,0-9",
      currentSociety: 0,
      disableButton: false,
      rules: {
        required: (value) => !!value || this.$t("field.required"),
        min: (v) => v.length >= 8 || this.$t("field.min-8"),
      },
      socData: [],
      nameAvailable: true,
    };
  },
  computed: {
    socIsValid() {
      if (this.currentSociety > 0) {
        return true;
      } else {
        return false;
      }
    },
    iconAvailable() {
      if (this.nameAvailable) {
        return "mdi-check-circle";
      } else {
        return "mdi-close-circle";
      }
    },
    colorAvailable() {
      if (this.nameAvailable) {
        return "";
      } else {
        return "error";
      }
    },
  },
  created() {
    this.getSociety();
  },
  methods: {
    copy() {
      // Only work in https
      if (navigator.clipboard) {
        navigator.clipboard.writeText(this.userData.password).then(() => {
          //
        });
      } else {
        const dummy = document.createElement("input");
        document.body.appendChild(dummy);
        dummy.setAttribute("value", this.userData.password);
        dummy.select();
        document.execCommand("copy");
        dummy.remove();
      }
    },
    checkName() {
      this.societyConnector
        .checkDuplicate(30, this.userData.login, 0)
        .then((isAvailable) => {
          this.nameAvailable = isAvailable;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    randomPass() {
      let charactersArray = this.characters.split(",");
      let characterSet = "";
      let password = "";

      if (charactersArray.indexOf("a-z") >= 0) {
        characterSet += "abcdefghijklmnopqrstuvwxyz";
      }
      if (charactersArray.indexOf("A-Z") >= 0) {
        characterSet += "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      }
      if (charactersArray.indexOf("0-9") >= 0) {
        characterSet += "0123456789";
      }
      if (charactersArray.indexOf("#") >= 0) {
        characterSet += "!%&*$#@";
      }

      for (let i = 0; i < this.size; i++) {
        password += characterSet.charAt(Math.floor(Math.random() * characterSet.length));
      }

      this.userData.password = password;
    },
    getSociety() {
      this.societyConnector.getSoc().then((response) => {
        this.socData = response;
      });
    },
    createUserData() {
      // Prevent double click on create
      this.disableButton = true;

      // Define new user socId with the one selected
      this.userData.socId = this.currentSociety;

      // Confirm last check of name available
      if (this.nameAvailable) {
        // Insert user in DB
        this.societyConnector
          .insertUser(this.userData)
          .then(() => {
            // Empty the password to prevent double click
            this.userData.password = "";
          })
          .finally(() => {
            // Permit to reenable create button
            this.disableButton = false;
          });
      }
    },
    autoComplete() {
      if (!this.userData.login.includes("@")) {
        this.userData.login = "admin@" + this.userData.login + ".fr";
        this.checkName();
      }

      this.randomPass();

      this.userData.phone = "05 46 52 52 52";
      this.userData.access = {
        name: this.$t("akito.admin"),
        permissions: "1|2|3|4|5|6|7|8|9",
      };

      this.copy();
    },
  },
};
</script>

<style></style>
